<template>
    <div id="opeRation">
        <div class="opera_img" ref="serchFixed" id="serchFixed">
            <div class="opera_title">
                <div class="opearbt">停车场综合管理运营平台</div>
                <div class="operatext">
                    <p>停车场综合管理运营平台包含集团停车综合管理监控平台和物业停车场经营管理系统。综合</p>
                    <p class="operatent">管理运营平台是面向单个或多个停车场的集中管理产品，可实现停车场的营收信息、联网监</p>
                    <p class="operatent">控、停车查询、财务对账、报表统计等的统一管理，提高管理效率，降低管理成本。</p>
                </div>
            </div>
        </div>
        <div>
            <el-tabs v-scroll v-model="active" @tab-click="handleClick">
                <!-- v-red ref="tabs" -->
                <el-tab-pane label="集团停车综合管理监控平台" name="1">
                    <div class="introduce">
                        <div class="intro_auto">
                            <div class="prointo">产品介绍</div>
                            <div class="proflex">
                                <div class="width_576">
                                    <div class="jituan">集团停车综合管理监控平台</div>
                                    <div class="jituan_text">
                                        <p>集团停车综合管理监控平台满足集团物业统一管理多个停车场的需</p>
                                        <p>求，实现集团所有停车场的营收信息、联网监控、停车查询、财务对</p>
                                        <p>账、报表统计等的统一管理，让集团管理者能清晰掌控集团管辖下的</p>
                                        <p>任意停车场运营状况。</p>
                                    </div>
                                </div>
                                <div class="width_576 pro_jiazhi">
                                    <div class="proValue">产品价值</div>
                                    <div class="proimage">
                                        <ul>
                                            <li>提升形象，打造信息化智慧停车场</li>
                                            <li>提高管理效率，降低管理成本</li>
                                            <li>统一运营，多维度展现停车场运营情况</li>
                                            <li>强化管理，集中监控，统一灵活调度</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="function">
                        <div class="funauto">
                            <div class="profun">产品功能</div>
                            <div class="flexpro">
                                <div class="probj">
                                    <div class="flexValue">
                                        <div>
                                            <div class="flex_title">联网管理</div>
                                            <div class="flex_text">
                                                <p>可查询集团各车场数据如</p>
                                                <p>停车记录、月卡数据等</p>
                                            </div>
                                        </div>
                                        <div class="paright">
                                            <div class="yuan_div">
                                                <div class="zhenfang"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flexValue valuetext">
                                        <div>
                                            <div class="flex_title">监控管理</div>
                                            <div class="flex_text">
                                                <p>联网监控集团多车场</p>
                                                <p>设备、人员情况</p>
                                            </div>
                                        </div>
                                        <div class="paright">
                                            <div class="yuan_div">
                                                <div class="jiankong"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flexValue valuetext">
                                        <div>
                                            <div class="flex_title">报表分析</div>
                                            <div class="flex_text">
                                                <p>集团多车场报表数据分析，</p>
                                                <p>辅助财务对账及管理决策</p>
                                            </div>
                                        </div>
                                        <div class="paright">
                                            <div class="yuan_div">
                                                <div class="yewu"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="computer"></div>
                                <div class="probj">
                                    <div class="flexValue valueleft">
                                        <div class="right">
                                            <div class="yuan_div">
                                                <div class="yewubanli"></div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="flex_title">业务办理</div>
                                            <div class="flex_text">
                                                <p>为车主办理停车场经营业务，</p>
                                                <p>管理月卡等</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flexValue valueleft valuetext">
                                        <div class="right">
                                            <div class="yuan_div">
                                                <div class="quanx"></div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="flex_title">权限控制</div>
                                            <div class="flex_text">
                                                <p>严格界定权限及业务流程，</p>
                                                <p>规范集团内部管理</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flexValue valueleft valuetext">
                                        <div class="right">
                                            <div class="yuan_div">
                                                <div class="xiaox"></div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="flex_title">消息通知</div>
                                            <div class="flex_text">
                                                <p>异常情况预警及消息推送机</p>
                                                <p>制，了解车场状况</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="advantage">
                        <div class="vantaauto">
                            <div class="vautatitle">产品优势</div>
                            <div class="vautaflex">
                                <div class="vanta">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/closePark/lianwnagkongzhi.png" />
                                    </div>
                                    <div class="vancenter vantext">联网管控</div>
                                    <div class="van_p">
                                        <p>打破集团不同车场数据孤岛现象</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/closePark/zongheyunying.png" />
                                    </div>
                                    <div class="vancenter vantext">综合运营</div>
                                    <div class="van_p">
                                        <p>多维度综合分析车场运营情况，</p>
                                        <p class="textpadd">优化车场管理模式</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/closePark/quanxianlinghuo.png" />
                                    </div>
                                    <div class="vancenter vantext">权限灵活</div>
                                    <div class="van_p">
                                        <p>满足各类组织架构对功能、数据</p>
                                        <p class="textpadd">权限的要求</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/closePark/duozhongduanchengxian.png" />
                                    </div>
                                    <div class="vancenter vantext">多终端呈现</div>
                                    <div class="van_p">
                                        <p>覆盖管理员不同场景下的使用习</p>
                                        <p class="textpadd">惯，提高管理工作效率</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="2" label="物业停车场经营管理系统">
                    <div class="introduce">
                        <div class="intro_auto">
                            <div class="prointo">产品介绍</div>
                            <div class="proflex">
                                <div class="width_576">
                                    <div class="jituan">物业停车场经营管理系统</div>
                                    <div class="jituan_text">
                                        <p>物业停车场经营管理系统为单个停车场管理提供综合管理服务，对停</p>
                                        <p>车场出入口设备智慧升级改造，实现停车各个出入口互通互联，提供</p>
                                        <p>车场数据采集、车牌识别、无卡出入、线上缴费、车位查找导航等功能。</p>
                                    </div>
                                </div>
                                <div class="width_576 pro_jiazhi">
                                    <div class="proValue">产品价值</div>
                                    <div class="proimage">
                                        <ul>
                                            <li>提高通行效率和泊位周转率</li>
                                            <li>降低停车场管理成本</li>
                                            <li>杜绝跑冒滴漏等违规现象</li>
                                            <li>增加车场停车收入</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="function">
                        <div class="funauto">
                            <div class="profun">产品功能</div>
                            <div class="flex_fun">
                                <div class="funguan">
                                    <div class="yuan">
                                        <div class="yygl"></div>
                                    </div>
                                    <div class="guanli">
                                        <div class="menu">
                                            <p>运营管理</p>
                                        </div>
                                        <div class="text">
                                            <p>记录停车场运营数据，并统计分析</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="funguan mar">
                                    <div class="yuan">
                                        <div class="jkgl"></div>
                                    </div>
                                    <div class="guanli">
                                        <div class="menu">
                                            <p>监控管理</p>
                                        </div>
                                        <div class="text">
                                            <p>联网监控，车场设备、人员情况一目了然</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex_fun funtext">
                                <div class="funguan">
                                    <div class="yuan">
                                        <div class="banli"></div>
                                    </div>
                                    <div class="guanli">
                                        <div class="menu">
                                            <p>业务办理</p>
                                        </div>
                                        <div class="text">
                                            <p>为车主办理停车场经营业务，管理月卡等</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="funguan mar">
                                    <div class="yuan">
                                        <div class="caiwu"></div>
                                    </div>
                                    <div class="guanli">
                                        <div class="menu">
                                            <p>财务对账</p>
                                        </div>
                                        <div class="text">
                                            <p>财务可对停车场运营收入进行对账</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="probg"></div>
                        </div>
                    </div>
                    <div class="advantage">
                        <div class="vantaauto">
                            <div class="vautatitle">产品优势</div>
                            <div class="vautaflex">
                                <div class="vanta">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/closePark/yuanyingguankong.png" />
                                    </div>
                                    <div class="vancenter vantext">运营管控</div>
                                    <div class="van_p">
                                        <p>管理人员对车场的运营状况一目</p>
                                        <p class="textpadd">了然</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/closePark/linghuopeizhi.png" />
                                    </div>
                                    <div class="vancenter vantext">灵活配置</div>
                                    <div class="van_p">
                                        <p>多项服务根据实际灵活配置，更</p>
                                        <p class="textpadd">贴合管理需求</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/closePark/guanfanguanli.png" />
                                    </div>
                                    <div class="vancenter vantext">规范管理</div>
                                    <div class="van_p">
                                        <p>严格的财务报表、反查核对机制</p>
                                        <p class="textpadd">规范收费员操作</p>
                                    </div>
                                </div>
                                <div class="vanta vanmar">
                                    <div class="vancenter vanimg">
                                        <img src="../../../common/img/product/closePark/quanxianlinghuo.png" />
                                    </div>
                                    <div class="vancenter vantext">业务稳定</div>
                                    <div class="van_p">
                                        <p>提供全天候的停车服务，对异常</p>
                                        <p class="textpadd">情况快速反应</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>

</template>
<script>
// import t from './t';
export default {
  data() {
    return {
      active: '1',
    };
  },
  created() {
    document.title = '集团停车综合管理监控平台';
  },
  mounted() {
    //滚动监听事件
  },
  methods: {
    handleClick(tab, event) {
      window.scrollTo(0, 0);
      if (tab.name == '1') {
        document.title = '集团停车综合管理监控平台';
      } else if (tab.name == '2') {
        document.title = '物业停车场经营管理系统';
      }
    },
  },
};
</script>
<style lang='scss'>
@import '../../../common/css/base';
</style>
